// src/redux/slices/filterSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    pricing: "",
    minPrice: null,
    maxPrice: null,
    rating: "",
    order: 1,
    subCategory: [],
};

const filterSlice = createSlice({
    name: "filters",
    initialState,
    reducers: {
        setFilter: (state, action) => {
            const { name, value } = action.payload;
            if (name === "subCategory") {
                const exists = state.subCategory.includes(value);
                if (exists) {
                    state.subCategory = state.subCategory.filter((item) => item !== value);
                } else {
                    state.subCategory.push(value);
                }
                return;
            }
            state[name] = value;
            if (name === "pricing") {
                state.minPrice = "";
                state.maxPrice = "";
                if (value === "Under 100") {
                    state.minPrice = 0;
                    state.maxPrice = 100;
                }
                if (value === "100 - 500") {
                    state.minPrice = 100;
                    state.maxPrice = 500;
                }
                if (value === "500 - 1000") {
                    state.minPrice = 500;
                    state.maxPrice = 1000;
                }
                if (value === "Above") {
                    state.minPrice = 1000;
                    state.maxPrice = null;
                }
                if (value === "Other") {
                    state.minPrice = null;
                    state.maxPrice = null;
                }
            }
        },
        resetFilters: () => initialState,
    },
});

export const { setFilter, resetFilters } = filterSlice.actions;
export default filterSlice.reducer;
